'use client'

import React, {useState} from 'react'
import clsx from 'clsx'
import {useScrollPosition} from '@n8tb1t/use-scroll-position'
import s from './style.module.css'
import {useFullScreen} from '@app/components/gameplayer-page/actions-section/buttons/full-screen/full-screen-provider'

interface NavbarProps {
  children: React.ReactNode
  hideOnScroll?: boolean
}

const HeaderWrapperClient: React.FC<NavbarProps> = ({children, hideOnScroll = true}) => {
  const yOffsect = -50
  const [isHeadVisible, setHeadVisibility] = useState<boolean>(true)
  const {isFullScreen} = useFullScreen()

  useScrollPosition(
    ({prevPos, currPos}) => {
      const isScrollingDown = currPos.y < prevPos.y
      if (isScrollingDown && currPos.y < yOffsect && hideOnScroll) {
        isHeadVisible && setHeadVisibility(false)
      } else {
        !isHeadVisible && setHeadVisibility(true)
      }
    },
    [isHeadVisible],
    undefined,
    false,
    350,
  )

  if (isFullScreen && !hideOnScroll) return null

  return (
    <header className={clsx(s.header, {[s.hidden]: !isHeadVisible, [s.desktop_header]: !hideOnScroll})}>
      {children}
    </header>
  )
}

export default HeaderWrapperClient
